<template>
  <template v-for="question in this.questions" v-bind:key="question.id">
    <!-- Question -->
    <div :class="{ hidden: question.isSupplimentary && !shouldBeVisible(question) }" class="mb-4"
      :id="'qindex-' + question.qindex" :style="completedStyle(question.qindex)">
      <div class="container flex mx-auto mb-4 p-4">
        <div v-if="question.isSupplimentary" class="flex w-12"></div>
        <div :class="{ 'flex-none w-5/6': question.isSupplimentary }">
          <h3 class="mt-2 mb-4 font-semibold text-brand-blue-400" v-html="question.title"></h3>

          <!-- Answers -->
          <template v-if="question.format === 'radio'">
            <div class="flex-none form-group">
              <template v-for="answer in question.answers" v-bind:key="answer.id">
                <div class="custom-control custom-radio">
                  <input type="radio" :id="answer.id" :name="question.id" :checked="isChecked(question.id, answer.id)"
                    v-on:change="this.updateResponses(question, answer)" :disabled="isDisabled()" />
                  <label class="ml-2 capitalize" :for="answer.id">{{
                    answer.title
                  }}</label>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
export default {
  props: ["questions", "review", "form", "adminView"],
  emits: ["update"],
  components: {},
  data() {
    return {
      arrayIndex: 0,
      hasBeenAnswered: []
    };
  },
  computed: {
    isVisiblez(id) {
      return true;
    },
  },
  mounted() {
    // TODO: AKM Make answered question indication work, currently it can't handle qindex-6-1 style responses.
    // for (let i = 0; i < this.review.responses.length; i++) {
    //   console.log(this.review.responses[i].question_id);
    //   this.hasBeenAnswered.push(this.review.responses[i].question_id);
    // }
  },
  methods: {
    incrementArrayIndex() {
      this.arrayIndex++;
      return this.arrayIndex;
    },
    isChecked(questionId, answerId) {
      for (let i = 0; i < this.form.responses.length; i++) {
        if (typeof this.form.responses[i] == "object") {
          {
            if (this.form.responses[i].answer_id === answerId) {
              this.form.newResponses[questionId] = answerId;
              return true;
            }
          }
        }
      }
      return false;
    },
    isDisabled() {
      if (this.review.status === "submitted" || this.adminView === true) {
        return true;
      } else {
        return false;
      }
    },
    shouldBeVisible(question) {
      if (question.isSupplimentary) {
        for (let i = 0; i < this.questions.length; i++) {
          let q = this.questions[i];
          for (let j = 0; j < q.answers.length; j++) {
            let a = q.answers[j];
            if (a.action_rule.startsWith("goto-")) {
              if (a.action_rule === "goto-" + question.qindex) {
                if (this.form.newResponses[q.id] === a.id) {
                  //   console.log("<<< shouldBeVisible (true)");
                  return true;
                } else {
                  //   console.log("<<< shouldBeVisible (false)");
                  return false;
                }
              }
            } else if (
              a.action_rule.startsWith("if-not-") &&
              a.action_rule.endsWith("-" + question.qindex)
            ) {
              let givenAnswers = this.getGivenAnswersFromActionRule(a.action_rule);
              //   console.dir(givenAnswers);
              if (
                givenAnswers[0] &&
                givenAnswers[1] &&
                givenAnswers[0].title === "no" &&
                givenAnswers[1].title === "no"
              ) {
                // console.log("<<< shouldBeVisible (true)");
                return true;
              } else {
                // console.log("<<< shouldBeVisible (false)");
                return false;
              }
            }
          }
        }
        // console.log("<<< shouldBeVisible (false)");
        return false;
      } else {
        // console.log("<<< shouldBeVisible (true)");
        return true;
      }
    },
    updateResponses(question, answer) {
      // TODO: AKM Make answered question indication work, currently it can't handle qindex-6-1 style responses.
      // this.hasBeenAnswered.push(question.qindex);

      if (
        question.hasSupplimentary &&
        this.form.newResponses[question.id] !== answer.id
      ) {
        let previousAnswer = question.answers.find(
          (a) => a.id === this.form.newResponses[question.id]
        );

        if (previousAnswer) {
          if (previousAnswer.action_rule.startsWith("goto-")) {
            let elementId = "qindex-" + previousAnswer.action_rule.substr(5);
            let element = document.getElementById(elementId);
            if (element && !element.classList.contains("hidden")) {
              element.classList.add("hidden");
            }
          } else if (previousAnswer.action_rule.startsWith("if-not-")) {
            /* if-not-<questionId>-and-not-<otherQuestionId>-goto-<targetQuestionId> */
            let givenAnswers = this.getGivenAnswersFromActionRule(
              previousAnswer.action_rule
            );
            // console.log("updateResponses() -> before updating the response");
            // console.dir(givenAnswers);
            let elementId =
              "qindex-" +
              previousAnswer.action_rule.substr(
                previousAnswer.action_rule.lastIndexOf("-") + 1
              );
            let element = document.getElementById(elementId);
            if (
              !(
                givenAnswers[0] &&
                givenAnswers[1] &&
                givenAnswers[0].title === "no" &&
                givenAnswers[1].title === "no" &&
                element
              )
            ) {
              //   console.log("Hide the extra question");
              element.classList.add("hidden");
            } else if (element) {
              //   console.log("Show the extra question");
              element.classList.remove("hidden");
            }
          }
        }
      }

      this.form.newResponses[question.id] = answer.id;

      if (question.hasSupplimentary) {
        if (question.qindex == "26" || question.qindex == "26-1") {
          /*
            |-------------------------------------------------------------------
            | TODO Implement proper action_rule based logic
            |-------------------------------------------------------------------
            |
            | Here I am short-cutting the logic for a very specific case where
            | we have a follow-on question to a follow-on question to this
            | question. Instead of building specific logic for this I
            | am merely hacking the logic that should otherwise
            | be driven by the action_rule
            |
            */
          if (!answer.action_rule.startsWith("goto-")) {
            let element = document.getElementById("qindex-26-2");
            if (element && !element.classList.contains("hidden")) {
              element.classList.add("hidden");
            }
          }
          if (question.qindex == "26" && answer.action_rule == "goto-26-1") {
            let q261 = this.questions.find((q) => q.qindex == "26-1");
            if (q261) {
              let a261Id = this.form.newResponses[q261.id];
              if (a261Id) {
                let a261 = q261.answers.find((a) => a.id == a261Id);
                if (a261 && a261.action_rule == "goto-26-2") {
                  let element = document.getElementById("qindex-26-2");
                  if (element && element.classList.contains("hidden")) {
                    element.classList.remove("hidden");
                  }
                }
              }
            }
          }
        }

        if (answer.action_rule.startsWith("goto-")) {
          let elementId = "qindex-" + answer.action_rule.substr(5);
          let element = document.getElementById(elementId);
          if (element) {
            element.classList.remove("hidden");
          }
        } else if (answer.action_rule.startsWith("if-not-")) {
          /* if-not-<questionId>-and-not-<otherQuestionId>-goto-<targetQuestionId> */
          let givenAnswers = this.getGivenAnswersFromActionRule(answer.action_rule);
          let elementId =
            "qindex-" +
            answer.action_rule.substr(answer.action_rule.lastIndexOf("-") + 1);
          //   console.log("updateResponses() -> after updating the response");
          //   console.dir(givenAnswers);
          let element = document.getElementById(elementId);
          if (
            givenAnswers[0] &&
            givenAnswers[1] &&
            givenAnswers[0].title === "no" &&
            givenAnswers[1].title === "no" &&
            element
          ) {
            element.classList.remove("hidden");
          } else if (element) {
            element.classList.add("hidden");
          }
        }
      }

      this.$nextTick(() => {
        this.$emit("update");
      });
    },
    getGivenAnswersFromActionRule(actionRule) {
      /* if-not-<questionId>-and-not-<otherQuestionId>-goto-<targetQuestionId> */

      if (!actionRule.startsWith("if-not-")) {
        return [];
      }

      let firstIdStart = 7;
      let firstIdEnd = actionRule.indexOf("-", firstIdStart) - 1;
      let firstIdLength = firstIdEnd - firstIdStart + 1;

      let secondIdStart = firstIdEnd + 10;
      let secondIdEnd = actionRule.indexOf("-", secondIdStart) - 1;
      let secondIdLength = secondIdEnd - secondIdStart + 1;

      let firstQuestionId = actionRule.substr(firstIdStart, firstIdLength);
      let secondQuestionId = actionRule.substr(secondIdStart, secondIdLength);

      let firstQuestion = this.questions.find((q) => q.qindex === firstQuestionId);
      let secondQuestion = this.questions.find((q) => q.qindex === secondQuestionId);

      let firstAnswerId = this.form.newResponses[firstQuestion.id];
      let secondAnswerId = this.form.newResponses[secondQuestion.id];

      let firstAnswer = firstQuestion.answers.find((a) => a.id === firstAnswerId);
      let secondAnswer = secondQuestion.answers.find((a) => a.id === secondAnswerId);

      return [firstAnswer, secondAnswer];
    },
    completedStyle(qIndex) {
      // TODO: AKM Make answered question indication work, currently it can't handle qindex-6-1 style responses.
      // var answered = false;

      // for (let i = 0; i < this.hasBeenAnswered.length; i++) {
      //   if (this.hasBeenAnswered[i] == qIndex) {
      //     answered = true;
      //   }
      // }
      // if (answered) {
      //   return "";
      // }

      // return "background-color: #fed43617";
    }
  },
};
</script>
